import * as React from 'react'

import { CardContent } from './card-content'
import { CardHeader } from './card-header'
import { classNames } from '@common/utils/helpers'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

type ShadowStyle = 'default'

interface CardProps extends React.HTMLAttributes<HTMLElement> {
  className?: string | undefined
  style?: any
  shadowStyle?: ShadowStyle
}

interface Card extends React.FC<CardProps> {
  Content: typeof CardContent
  Header: typeof CardHeader
}

const CardWrapper = styled.div`
  &.pq-card {
    border-radius: 16px;
    background-color: #ffffff;
  }
`

/**
 * @deprecated use {@palqee/ui/card}
 */
const Card: Card = (props) => {
  const { children, className, shadowStyle, ...rest } = props
  const classes = classNames('pq-card', className || '')

  const getShadowStyle = () => {
    switch (shadowStyle) {
      case 'default':
      default:
        return css`
          box-shadow: 0 2px 24px 0 rgba(223, 231, 255, 0.2);
        `
    }
  }

  const cardCss = [getShadowStyle()]

  return (
    <CardWrapper css={cardCss} className={classes} {...rest}>
      {children}
    </CardWrapper>
  )
}

Card.Header = CardHeader
Card.Content = CardContent

export { Card }
